import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

export interface TelehealthGuideDialogResult {
  continue: boolean;
  doNotShowAgain?: boolean;
}

@Component({
  standalone: false,
  selector: 'cva-telehealth-guide-dialog',
  templateUrl: './telehealth-guide-dialog.component.html',
  styleUrl: './telehealth-guide-dialog.component.scss',
})
export class TelehealthGuideDialogComponent {
  doNotShowAgain = false;
  previewImageSrc = 'assets/images/screen-share-guide.png';

  constructor(
    private readonly dialogRef: MatDialogRef<TelehealthGuideDialogComponent, TelehealthGuideDialogResult>,
  ) { }

  onCancel(): void {
    this.dialogRef.close({ continue: false });
  }

  onContinue(): void {
    this.dialogRef.close({
      continue: true,
      doNotShowAgain: this.doNotShowAgain,
    });
  }
}
